/* @flow */

import type { JSON } from 'common/types';
import { failure } from 'common/json/extract';

const id: JSON => string = (json: JSON) => {
  if (typeof json === 'string') {
    return json;
  } else if (typeof json === 'number') {
    return String(json);
  }
  return failure(`Expecting id (number or string), got ${typeof json}`, () =>
    String(json)
  );
};

export default id;
